import { render } from "./App.vue?vue&type=template&id=0983a506"
const script = {}

import exportComponent from "C:\\Folders\\Frontend\\Projects\\dniils.github\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__